import { apiClient } from './client';
import type { User, CreateUserInput, UpdateUserInput } from '../../types';

export const usersService = {
  list: async (params?: { limit?: number; offset?: number }): Promise<{ users: User[] }> => {
    return apiClient.get<{ users: User[] }>('/api/v1/users', params);
  },

  getById: async (id: string): Promise<User> => {
    return apiClient.get<User>(`/api/v1/users/${id}`);
  },

  create: async (input: CreateUserInput): Promise<User> => {
    return apiClient.post<User>('/api/v1/users', input);
  },

  update: async (id: string, input: UpdateUserInput): Promise<User> => {
    return apiClient.patch<User>(`/api/v1/users/${id}`, input);
  },
};
